/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexObjectDto } from '../../models/backend-capex-object-dto';
import { BackendCapexObjectRequestDto } from '../../models/backend-capex-object-request-dto';

export interface EconomicIndicatorsCapexObjectSettingsUpdate$Params {
  /**
   * A unique integer value identifying this capex object.
   */
  id: number;
  body: BackendCapexObjectRequestDto;
}

export function economicIndicatorsCapexObjectSettingsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexObjectSettingsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexObjectSettingsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexObjectDto>;
    }),
  );
}

economicIndicatorsCapexObjectSettingsUpdate.PATH = '/api/economic_indicators/capex_object_settings/{id}/';
